export abstract class MarketplaceRedirectService {
    abstract redirect(): void;
    abstract redirectWithProducts(): void;
    abstract redirectToPortalPrivado(): void;
    abstract redirectToTrazabilidad(): void;
    abstract redirectWithProductsAndToken(): void;
    abstract redirectOld(): void;
    abstract redirectPortalPublico(): void;
    abstract redirectToTbkAmigo(): void;
}
